"use client";

import { useEffect } from "react";
import { useSiteSettings } from "@/modules/web/hooks/useSiteSettings";
import { THEME_STYLE_ELEMENT_ID, buildThemeCss } from "@/lib/regionTheme";

/**
 * Re-applies the palette when settings are refetched on the client (a locale
 * switch, or a client-side navigation into another region). The root layout is
 * preserved across those navigations, so the server-rendered
 * <RegionThemeStyle> would otherwise keep serving the palette of whichever
 * region happened to render first.
 *
 * It rewrites that same <style> element rather than setting inline custom
 * properties on <html>: an inline style would outrank the `.dark` rules from
 * globals.css and freeze the app in its light palette.
 */
export default function RegionThemeSync() {
  const settings = useSiteSettings();
  const css = buildThemeCss(settings?.theme);

  useEffect(() => {
    if (!css) {
      return;
    }

    let style = document.getElementById(THEME_STYLE_ELEMENT_ID);

    if (!(style instanceof HTMLStyleElement)) {
      style = document.createElement("style");
      style.id = THEME_STYLE_ELEMENT_ID;
      document.head.appendChild(style);
    }

    if (style.textContent !== css) {
      style.textContent = css;
    }
  }, [css]);

  return null;
}
